import { render, staticRenderFns } from "./OneTimeRideList.vue?vue&type=template&id=547315da&scoped=true"
import script from "./OneTimeRideList.vue?vue&type=script&lang=js"
export * from "./OneTimeRideList.vue?vue&type=script&lang=js"
import style0 from "./OneTimeRideList.vue?vue&type=style&index=0&id=547315da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547315da",
  null
  
)

export default component.exports